import { useMemo, useState } from 'react';
import { MeasurementRange } from '../../../../../../types';
import { getDateRangeByPage, getRangeLabel } from '../../../../../../utils/charts/charts';

export const useNavigateCharts = () => {
  const [page, setPage] = useState<number>(0);
  const [activeRange, setActiveRange] = useState<MeasurementRange>(MeasurementRange.DayInHours);

  const onClickActiveMeasurementRange = (value: MeasurementRange) => {
    setActiveRange(value);
    setPage(0);
  };

  const fromTo = useMemo(() => getDateRangeByPage(activeRange, page), [activeRange, page]);

  const currentRangeLabel = getRangeLabel(activeRange, fromTo);

  return {
    activeRange,
    page,
    currentRangeLabel,
    dateFromRange: new Date(new Date(fromTo.from).setHours(2, 0, 0, 0)),
    onClickActiveMeasurementRange,
    setPage,
  };
};
